import type { GetServerSideProps } from "next";
import Head from "next/head";
import { FC, useEffect } from "react";

import { Disclaimers } from "../components/Disclaimers";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { BrokerCheck } from "../sections/BrokerCheck";
import { ComingSoon } from "../sections/home/ComingSoon";
import { BlogList } from "../sections/resources/BlogList";
import { getBlogPosts, PostType } from "../utils/blogApi";
import { getServerSidePropsHelper } from "../utils/serverSidePropsHelper";

type BlogProps = {
  posts: PostType[] | null;
  isKnownUser: boolean;
};

const Blog: FC<BlogProps> = ({ posts, isKnownUser }) => {
  const title =
    "Resources - Learn about direct indexing, treasury, and margin loans";

  const description = "Build financial literacy with in-depth articles.";

  useEffect(() => {
    if (posts === null) {
      // eslint-disable-next-line no-console
      console.log("Did not find blog posts on Resources");
    }
  }, [posts]);

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="canonical" href="https://frec.com/resources" />
        <meta name="description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta
          property="og:image"
          content="https://frec.com/webstatic/images/share-img.png"
          key="og:image"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <>
        <Header isKnownUser={isKnownUser} />
        <main>
          {posts && posts.length ? <BlogList posts={posts} /> : <ComingSoon />}
        </main>
        <BrokerCheck />
        <Footer />
        <Disclaimers />
      </>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<BlogProps> = async ({
  req,
}) => {
  const props = getServerSidePropsHelper(req);
  const posts = await getBlogPosts();
  return Promise.resolve({
    props: { posts, ...props },
  });
};

export default Blog;
